import { createFileRoute } from "@tanstack/react-router";
import { peopleSearchSchema } from "@/features/people/model";
import { PeoplePage } from "@/features/people/people-page";

/** People (ALP-84 S5): Everyone (`?view=everyone`, default) and Commenters (`?view=commenters`) on one page. */
export const Route = createFileRoute("/_app/people/")({
  validateSearch: peopleSearchSchema,
  head: () => ({ meta: [{ title: "People · Malfak" }] }),
  component: PeopleRoute,
});

function PeopleRoute() {
  const search = Route.useSearch();
  return <PeoplePage search={search} />;
}
